import React from 'react';
import { useIntl } from 'react-intl';

export interface SubCategory {
  id: number;
  icon: string;
  title: string;
  description: string | React.ReactNode;
  tarif: string;
  iconBg: string;
  urlCommande: string;
  urlEnSavoirPlus?: string;
  isActive: boolean;
}

export interface Category {
  id: number;
  icon: string;
  title: string;
  description: string | React.ReactNode;
  iconBg: string;
  urlCommande?: string;
  urlEnSavoirPlus?: string;
  isActive: boolean;
  subCategories?: SubCategory[];
}

interface CategoryCardProps {
  category: Category;
  onOrder: (title: string) => void;
  onLearnMore: (title: string) => void;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ category, onOrder, onLearnMore }) => {
  const intl = useIntl();
  return (
    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
      <div className="card h-100 shadow-sm">
        <div className="card-body d-flex flex-column">
          {/* Icône */}
          <div className="symbol symbol-50px mb-4 d-flex justify-content-center">
            <span className="symbol-label">
              <i className={`${category.icon} fs-2x text-${category.iconBg}`}></i>
            </span>
          </div>

          {/* Titre */}
          <h3 className="card-title fw-bold fs-4 mb-3 text-center">{category.title}</h3>

          {/* Description */}
          <p className="card-text text-gray-600 mb-4 flex-grow-1">{category.description}</p>

          {/* Boutons */}
          <div className="d-flex flex-column gap-2">
            <button
              className={category.isActive ? `btn btn-${category.iconBg} btn-sm` : 'btn btn-sm'}
              onClick={() => category.isActive && onOrder(category.title)}
              disabled={!category.isActive}
              style={
                !category.isActive
                  ? {
                      backgroundColor: '#A7A7A7',
                      color: 'white',
                      border: 'none',
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            >
              {category.isActive ? (
                <>
                  <i className="fa-solid fa-cart-shopping me-2" style={{color: 'white'}} />
                  {intl.formatMessage({id: 'COMMON.ORDER_NOW'})}
                </>
              ) : (
                <>{intl.formatMessage({id: 'COMMON.COMING_SOON'})}</>
              )}

            </button>
            <button
              className={`${category.isActive ? 'btn btn-light-primary btn-sm' : 'btn btn-sm'} ${
                !category.urlEnSavoirPlus ? 'invisible' : ''
              }`}
              onClick={() => category.isActive && onLearnMore(category.title)}
              disabled={!category.isActive}
              style={
                !category.isActive
                  ? {
                      backgroundColor: 'white',
                      color: '#A7A7A7',
                      border: '1px solid #A7A7A7',
                      cursor: 'not-allowed',
                      pointerEvents: 'none',
                    }
                  : {}
              }
            >
              <i className="fa-solid fa-circle-info me-2"></i>
              {intl.formatMessage({id: 'COMMON.LEARN_MORE'})}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryCard;
